import {
    START_LOADING,
    END_LOADING,
    FETCH_ASSETS,
    FETCH_ASSET,
    ADD_ASSET,
    UPDATE_ASSET,
    DELETE_ASSET,
  } from "../actions/constants";
  
  const initialState = {
    isLoading: false,
    assets: [],
    asset: null,
  };
  
  const assets = (state = initialState, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true };
      case END_LOADING:
        return { ...state, isLoading: false };
      case FETCH_ASSETS:
        return {
          ...state,
          assets: action.payload.data,
          numberOfPages: action.payload.numberOfPages,
        };
      case FETCH_ASSET:
        return { ...state, asset: action.payload };
      case ADD_ASSET:
        return {
          ...state,
          assets: [...state.assets, action.payload],
          asset: action.payload, 
        };
      case UPDATE_ASSET:
        return {
          ...state,
          assets: state.assets.map((asset) =>
            asset._id === action.payload._id ? action.payload : asset
          ),
          asset:
            state.asset && state.asset._id === action.payload._id
              ? action.payload
              : state.asset,
        };
      case DELETE_ASSET:
        return {
          ...state,
          assets: state.assets.filter((asset) => asset._id !== action.payload),
          asset:
            state.asset && state.asset._id === action.payload
              ? null
              : state.asset,
        };
      default:
        return state;
    }
  };
  
  export default assets;
  